import { Link } from "react-router-dom";
import { Btn } from "@/components/ui/Btn/Btn";
import type { AuthView } from "./AtmosphericPanel";
import styles from "./AuthTopBar.module.css";

interface AuthTopBarProps {
  view: AuthView;
}

/**
 * Header on every auth screen: brand mark on the left, context-aware
 * "Sign in" / "Sign up" CTA on the right (mirrors whichever the user
 * isn't currently looking at).
 */
export function AuthTopBar({ view }: AuthTopBarProps) {
  const ctaLabel = view === "signin" ? "Sign up" : "Sign in";
  const ctaTarget = view === "signin" ? "/signup" : "/signin";
  const prompt = view === "signin" ? "Don’t have an account?" : "Already have an account?";

  return (
    <header className={styles.bar}>
      <Link to="/" className={styles.brand}>
        <span className={styles.mark} aria-hidden="true">
          ✻
        </span>
        <span className={styles.brandName}>Notamen</span>
      </Link>
      <div className={styles.spacer} />
      <div className={styles.cta}>
        <span className={styles.prompt}>{prompt}</span>
        <Btn href={ctaTarget} variant="secondary" size="sm">
          {ctaLabel}
        </Btn>
      </div>
    </header>
  );
}
